import api from "./client";

export async function listShiftEntryOperators(workCenterId) {
  const res = await api.get("/shift-production/operators", { params: { work_center_id: workCenterId } });
  return res.data.data.items;
}

export async function createShiftProductionEntry(productionOrderId, routingOperationId, payload) {
  const res = await api.post(
    `/shift-production/orders/${productionOrderId}/operations/${routingOperationId}`,
    payload,
  );
  return res.data.data;
}

export async function listShiftProductionEntries(params = {}) {
  const res = await api.get("/shift-production/entries", { params });
  return res.data.data.items;
}

export async function correctShiftProductionLot(approvalId, allocationId, payload) {
  const res = await api.patch(
    `/shift-production/approvals/${approvalId}/lots/${allocationId}`,
    payload,
  );
  return res.data.data;
}

export async function reverseBaskiProductionLot(approvalId, allocationId, reason) {
  const res = await api.post(
    `/shift-production/approvals/${approvalId}/lots/${allocationId}/reverse`,
    { reason },
  );
  return res.data.data;
}
